<template>
    <div>

        <sub-menu-call-center ativo="info" v-if="!na_recepcao && !no_faturamento && !na_autorizacao" />
        <sub-menu-faturamento ativo="info" v-if="no_faturamento" />

        <div class="row">

            <div class="col col-12 col-md-8">

                <!-- Seleção da Unidade -->

                <div class="row d-flex justify-content-center mb-2">

                    <div class="col col-12">

                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa fa-building fa-fw" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="dados.unidade_operacao">
                                <option value="">Unidade...</option>
                                <option v-for="(und, iux) in this.$store.state.unidade.unidade_operacaos" :value="und" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>

                    </div>

                </div>

                <!-- Seleção da Operadora / Plano -->

                <div class="row d-flex justify-content-center mb-2">

                    <div class="col col-12">

                        <az-input
                            placeholder="Operadora/Plano..."
                            icon="far fa-credit-card"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="planos.index"
                            :optionsSync="false"
                            :optionsParm="{
                                atendimento: true,
                                plano_id_unidade_operacao: dados.unidade_operacao ? dados.unidade_operacao.id_unidade_operacao : null,
                            }"
                            v-model="dados.plano"
                            ref="info_plano" />

                    </div>

                </div>

                <!-- Seleção do Procedimento -->

                <div class="row d-flex justify-content-center mb-2">

                    <div class="col col-12">

                        <az-input 
                            placeholder="Procedimento..."
                            icon="fas fa-play"
                            type="autocomplete" 
                            optionsMode="aql"
                            optionsName2="procedimentos.index.info" 
                            optionsParm2="{ ativos: true }"
                            :optionsName="( $store.state.user.proc_oper ? 'procedimentos.agenda.op.' + ( dados.plano ? ( dados.plano.id_operadora == 1 ? 'p.' + dados.plano.id_plano : dados.plano.id_operadora ) : '' ) : 'procedimentos.agenda' )
                                + ( dados.unidade_operacao ? '.uo' + dados.unidade_operacao.id_unidade_operacao : null )"
                            :optionsParm="$store.state.user.proc_oper 
                                ? { 
                                    id_operadora: dados.plano ? dados.plano.id_operadora : null, 
                                    id_plano: dados.plano ? dados.plano.id_plano : null, 
                                    id_unidade_operacao: dados.unidade_operacao ? dados.unidade_operacao.id_unidade_operacao : null,
                                    cc: false, 
                                    infusao: false, 
                                } 
                                : {
                                    id_unidade_operacao: dados.unidade_operacao ? dados.unidade_operacao.id_unidade_operacao : null, 
                                    cc: false,
                                    infusao: false, 
                                }"
                            :optionsSync="false"
                            service="procedimentos.index"
                            v-model="dados.procedimento"
                            ref="info_procedimento" />

                    </div>

                </div>

                <!-- Selecionar Médico -->

                <div class="row d-flex justify-content-center mb-2">

                    <div class="col col-12">

                        <az-input 
                            placeholder="Profissional..."
                            icon="fas fa-briefcase-medical"
                            type="autocomplete" 
                            service="medicos.index"
                            optionsDisplay="st_nome_exibicao"
                            v-model="dados.medico"
                            ref="info_medico" />

                    </div>

                </div>

                <!-- Selecionar CID -->

                <div class="row d-flex justify-content-center mb-3">

                    <div class="col col-12">

                        <AzInput placeholder="CID..."
                                icon="fas fa-comment-medical"
                                type="autocomplete" 
                                service="cids.index"
                                optionsDisplay="search"
                                v-model="dados.cid" />

                    </div>

                </div>
                    
            </div>

        </div>

        <!-- PROFISSIONAL -->

        <div class="card" v-if="info && info.medico">
            <div class="card-header d-flex justify-content-between">
                <div>
                    <i class="fas fa-briefcase-medical mr-2"></i>
                    {{ info.medico.st_nome_exibicao }}
                    <div v-if="info.medico.medico_especialidade">
                        <span class="badge badge-primary mr-1" v-for="(me, imx) in info.medico.medico_especialidade" :key="imx">
                            {{ me.especialidade.search }}
                        </span>
                    </div>
                </div>
                <div>
                    <div class="text-right">
                        <template v-if="info.medico.pessoa.st_nome != info.medico.st_nome_exibicao">
                            {{ info.medico.pessoa.st_nome }}<br>
                        </template>
                        {{ info.medico.numero_formatado }}
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <div v-if="info.medico.medico_unidade.ch_paciente_sexo">
                            Atende apenas pacientes do sexo: {{ info.medico.medico_unidade.ch_paciente_sexo }}
                        </div>
                        <div v-if="info.medico.medico_unidade.in_paciente_idade_minima > 0">
                            Atende apenas pacientes a partir de {{ info.medico.medico_unidade.in_paciente_idade_minima }} ano(s)
                        </div>
                        <div v-if="info.medico.medico_unidade.in_paciente_idade_maxima && info.medico.medico_unidade.in_paciente_idade_maxima < 999">
                            Atende apenas pacientes até {{ info.medico.medico_unidade.in_paciente_idade_maxima }} anos
                        </div>
                        <span v-if="info.medico.medico_unidade" v-html="info.medico.medico_unidade.st_instrucao">
                        </span>
                        <span v-else>
                            Nenhuma instrução cadastrada.
                        </span>
                    </div>
                    <div class="col col-auto" v-if="info.medico.logo && info.medico.logo.arquivo && info.medico.logo.arquivo.temporary_url" >
                        <img :src="info.medico.logo.arquivo.temporary_url" class="img-fluid img-thumbnail float-right" 
                            style="max-width: 200px; max-height: 150px;">
                    </div>
                </div>
            </div>
        </div>

        <!-- PROCEDIMENTO -->

        <div class="card" v-if="info && info.procedimento">
            <div class="card-header">
                <i class="fas fa-play mr-2"></i>
                {{ info.procedimento.st_procedimento }}
                <div v-if="info.procedimento.especialidade">
                    <span class="badge badge-primary">
                        {{ info.procedimento.especialidade.search }}
                    </span>
                </div>
            </div>
            <div class="card-body">
                <div v-if="info.procedimento.in_prazo_entrega">
                    Prazo de entrega: {{ info.procedimento.in_prazo_entrega }} 
                    <span v-if="info.procedimento.st_tempo_prazo_entrega == 'horas'">hora(s)</span>
                    <span v-else-if="!info.procedimento.st_tempo_prazo_entrega || info.procedimento.st_tempo_prazo_entrega == 'days'">dia(s)</span>
                    <span v-else>{{ info.procedimento.st_tempo_prazo_entrega }}</span>
                    <hr>
                </div>

                <span v-if="info.procedimento.unidade_procedimento && info.procedimento.unidade_procedimento.instrucao 
                    && ( info.procedimento.unidade_procedimento.instrucao.st_instrucao || info.procedimento.unidade_procedimento.instrucao.st_instrucao_agenda_online )">
                    <span style="white-space: pre-line;">{{ info.procedimento.unidade_procedimento.instrucao.st_instrucao }}</span>
                    <span v-if="info.procedimento.unidade_procedimento.instrucao.st_instrucao && info.procedimento.unidade_procedimento.instrucao.st_instrucao_agenda_online">
                        <hr>
                    </span>
                    <span style="white-space: pre-line;">{{ info.procedimento.unidade_procedimento.instrucao.st_instrucao_agenda_online }}</span>
                </span>

                <span v-else>
                    Nenhuma instrução registrada para o procedimento.
                </span>
            </div>

            <!-- Restrições -->
            <div class="card-body" :class="'alert-' + restricao.color" v-for="(restricao, irx) in info.restricoes" :key="irx">
                <div>
                    <i :class="restricao.icon" class="mr-2"></i>
                    <strong>{{ restricao.title }}</strong>
                </div>
                <div>
                    <span v-html="restricao.text"></span>
                </div>
            </div>

        </div>

        <!-- OPERADORA / PLANO -->

        <div class="card" v-if="info && info.plano">
            <div class="card-header d-flex justify-content-between">
                <div>
                    <i class="far fa-credit-card mr-2"></i>
                    {{ info.plano.search }}
                </div>
                <div v-if="info.plano.operadora.st_registro_ans">
                    ANS: {{ info.plano.operadora.st_registro_ans }}
                </div>
            </div>
            <div class="card-body">
                <template v-if="info.instruc_oper">
                    <div v-for="(instruc, iix) in info.instruc_oper" :key="iix">
                        <div>
                            {{ instruc.title }}
                        </div>
                        <small v-html="instruc.text" class="mb-3"></small>
                    </div>
                </template>
            </div>
        </div>

        <!-- UNIDADE -->

        <div class="card" v-if="info && info.unidade_operacao">
            <div class="card-header d-flex justify-content-between">
                <div>
                    <i class="fa fa-building mr-2"></i>
                    {{ info.unidade_operacao.st_nome }}
                </div>
            </div>
            <div class="card-body">
                <div v-if="info.unidade_operacao.endereco">
                    <a :href="info.unidade_operacao.endereco.st_map_link" target="_blank">
                        <i class="fas fa-map-marker-alt mr-2"></i>
                    </a>
                    {{ info.unidade_operacao.endereco.exibir }}
                </div>
                <div class="mt-3">
                    <span class="badge mr-1" v-for="(oper, iox) in info.operadoras" :key="iox"
                        :class="( oper.unidade_operadora && oper.unidade_operadora.fl_ativo ) ? 'badge-success' : 'badge-danger'">
                        <i class="fa fa-check mr-1" v-if="oper.unidade_operadora && oper.unidade_operadora.fl_ativo"></i>
                        <i class="fa fa-ban mr-1" v-else></i>
                        {{ oper.st_operadora }}
                    </span>
                </div>            
            </div>
            <div class="card-body" v-if="info.unidade_operacao.procedimento_lista && info.unidade_operacao.procedimento_lista.length">
                <div><strong>Procedimentos não Realizados</strong></div>
                <div v-for="(proced, ipx) in info.unidade_operacao.procedimento_lista" :key="ipx">
                    <i class="fa fa-ban text-danger mr-2" aria-hidden="true"></i>
                    {{ proced.procedimento.search }}
                </div>
            </div>
        </div>

        <pre v-if="false">{{ info }}</pre>

    </div>
</template>

<script>
import SubMenuCallCenter from './SubMenuCallCenter.vue';
import SubMenuFaturamento from '../faturamento/SubMenuFaturamento.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            dados: { 
                medico: "",
                procedimento: "",
                plano: "",
                unidade_operacao: "", 
                cid: "", 
            },
            info: null, 
            montado: false,
        }
    },

    watch: { 
        dados: { 
            handler () { 
                this.load ();
            },
            deep: true, 
            immediate: true, 
        }
    },

    components: { 
        AzInput,
        SubMenuCallCenter,
        SubMenuFaturamento, 
    },

    computed: { 
        na_autorizacao: function () { 
            return this.$route.path.substr(0,13) == '/autorizacoes';
        },

        na_recepcao: function () { 
            return this.$route.path.substr(0,9) == '/recepcao';
        },

        no_faturamento: function () { 
            return this.$route.path.substr(0,12) == '/faturamento';
        },

        contexto: function () { 
            return this.na_autorizacao
                ? 'Z'
                : ( this.no_faturamento 
                    ? 'F'
                    : ( this.na_recepcao ? 'R' : 'C' )
                ); 
        }
    },

    methods: { 
        load() { 
            if ( !this.montado )
                return;

            this.$util.load(this, { 
                service: 'instrucoes', 
                func: 'informacoes',
                parms: { 
                    ...this.dados,
                    contexto: this.contexto, 
                }, 
                loadTo: res => { 
                    this.info = res;
                }
            });
        }
    },

    mounted() { 
        if ( this.na_recepcao ) { 
        
            this.$store.commit("setBreadcrumb", [
                { name: "Recepção", path: "/recepcao" },
                { name: "Informações" }
            ]);
        
        } else if ( this.no_faturamento ) { 
        
            this.$store.commit("setBreadcrumb", [
                { name: "Faturamento", path: "/faturamento/guias" },
                { name: "Informações", path: "/faturamento/info" }
            ]);
        
        } else { 

            this.$store.commit("setBreadcrumb", [
                { name: "Call Center", path: "/call-center" },
                { name: "Informações" }
            ]);

        }
        
        this.$nextTick(() => { 
            this.montado = true;
        });
    }
}
</script>